/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pb_Publish_DocsInputs */

const en_pb_publish_docs = /** @type {(inputs: Pb_Publish_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Field reference in the docs →`)
};

const id_pb_publish_docs = /** @type {(inputs: Pb_Publish_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rincian kolom ada di dokumentasi →`)
};

/**
* | output |
* | --- |
* | "Field reference in the docs →" |
*
* @param {Pb_Publish_DocsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pb_publish_docs = /** @type {((inputs?: Pb_Publish_DocsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pb_Publish_DocsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pb_publish_docs(inputs)
	return en_pb_publish_docs(inputs)
});